export default __webpack_public_path__ + "static/media/84.97bbfeb7.jpeg";